import { useCallback, useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useSceneElement } from '@editor/hooks'
import SlabDrawing from '../../../SlabDrawing'
import { SlabFormSchema } from '../../schema'

interface Props {
  element: string
}

const RoofFormScene = ({ element }: Props) => {
  const { setValue } = useFormContext()

  const formPoints = useWatch<SlabFormSchema>({ name: 'points' }) as {
    x: number
    y: number
    z: number
  }[]

  const updatePoints = useCallback(
    (points: SlabFormSchema['points']) => {
      setValue('points', points)
    },
    [setValue],
  )

  const sceneElement = useMemo(
    () => ({
      enabled: true,
      properties: {
        points: formPoints,
        updatePoints,
        element,
      },
      component: SlabDrawing,
      // SlabDrawing keeps refs to its edge lines that only a remount resets (e.g. after a
      // corner is removed), so new points re-register it instead of updating it in place
      updateInPlace: false,
    }),
    [formPoints, updatePoints, element],
  )

  useSceneElement(sceneElement)

  return null
}

export default RoofFormScene
